import { lazy, Suspense } from 'react';
import React, { useState, useEffect, useRef } from 'react';


/// Components
import Router from "./jsx/Router";
import { useSelector, useDispatch } from 'react-redux';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { history } from './_helpers';

/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import "./css/commonStyle.css";
import { authActions } from './_store';

const Login = lazy(() => import('./jsx/pages/unauthorized/Login'));
const Privacy = lazy(() => import('./jsx/pages/unauthorized/Privacy'));
const ForgotPassword = lazy(() => import('./jsx/pages/unauthorized/ForgotPassword'));


export { App };

function App() {

    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();


    const { user: authUser } = useSelector(x => x.auth);

    const dispatch = useDispatch();

    // State to manage authentication status
    const [isAuthenticated, setIsAuthenticated] = useState(true); // Assuming the user starts as authenticated

    const deferredPrompt = useRef('');

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', function (e) {
            e.preventDefault();
            deferredPrompt.current = e;

            var a2hsBtn = document.querySelector(".add-to-homescreen-button");
            a2hsBtn.style.visibility = "visible";

        });

       
    }, []);


    useEffect(() =>{
      
        const [pathname, url] = history?.location?.pathname?.split("/")?.filter((x)=> x.trim() !== "" )
            
          if(pathname && pathname !== 'OrderList' && pathname !== 'ViewOrder' && pathname !== 'AddEditOrder' && pathname !== 'DispatchDetails' && pathname !== 'OrderPreparation'){
            
              if(localStorage.getItem('filterValues')){
                  localStorage.removeItem('filterValues')
              }
          }

          if(pathname && pathname !== 'productlist' &&  pathname !== 'CreateProduct'){
            if(localStorage.getItem('storeValues')){
                localStorage.removeItem('storeValues');
              }
          }

   //persist or Remove Stockmanagement Search values       
          if(pathname && pathname !== 'StockManagement' &&  pathname !== 'inventoryHistory'){
            if(localStorage.getItem('stockValues')){
                localStorage.removeItem('stockValues');
              }
          }

//persistSelectedValues Dropdown
 if(pathname && pathname !== 'ViewOrder' &&  pathname !== 'TransactionProductReport'){
            if(localStorage.getItem('selectedProduct')){
                localStorage.removeItem('selectedProduct');
              }
              if(localStorage.getItem('transactionTable')){
                localStorage.removeItem('transactionTable');
              }
          }
           
 },[history?.location?.pathname]);

    // Effect to handle session expiration
    useEffect(() => {
        let sessionTimer;

        // Function to be called when the session expires
        const handleSessionExpiration = () => {
            setIsAuthenticated(false); // Update the authentication status
            // You might want to redirect the user to a login page or perform other actions
            dispatch(authActions.logout({}));


        };

        // Set a timer for session expiration (e.g., 15 minutes)
        // Retrieve session timeout from environment variable or use a default value

        const sessionTimeout = process.env.REACT_APP_SESSION_TIMEOUT; // 30 * 60 * 1800000; // 15 minutes in milliseconds
        // Reset the timer on user activity (e.g., mousemove, keydown)
        const resetSessionTimer = () => {
            clearTimeout(sessionTimer);
            sessionTimer = setTimeout(handleSessionExpiration, sessionTimeout);
        };

        // Attach event listeners for user activity
        window.addEventListener('mousemove', resetSessionTimer);
        window.addEventListener('keydown', resetSessionTimer);

        // Set up the initial session timer
        resetSessionTimer();

        // Clean up event listeners on component unmount
        return () => {
            window.removeEventListener('mousemove', resetSessionTimer);
            window.removeEventListener('keydown', resetSessionTimer);
            clearTimeout(sessionTimer);
        };
    }, [isAuthenticated]);


    const handleInstallClick = () => {
        var a2hsBtn = document.querySelector(".add-to-homescreen-button");
        a2hsBtn.style.visibility = "hidden";
        deferredPrompt.current.prompt();
        deferredPrompt.current.userChoice.then(function (choiceResult) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'pwaInstall',
                'Install': choiceResult.outcome,
            });
            deferredPrompt.current = null;
        });

    };

    const handleCloseInstall = () => {
        var a2hsBtn = document.querySelector(".add-to-homescreen-button");
        a2hsBtn.style.visibility = "hidden";
    };


    let routes = (
        <Routes>
            <Route path="*" element={<Login />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/QB/privacy" element={<Privacy />} />
        </Routes>
    );

    let shortcutURL = (
        <div className="add-to-homescreen-button align-vertically-center" style={{ visibility: "hidden" }} >
            <div className="text-accept align-vertically-center">Add to Homescreen? </div>
            <div className="accept-button align-vertically-center" onClick={() => handleInstallClick()}>✓</div>
            <div className="reject-button align-vertically-center" onClick={() => handleCloseInstall()}>X</div>
        </div>
    );

    let bodyHtml = "";
    if (authUser && authUser.Token && authUser.OutputStatus === 1 && authUser.Id > 0) {
        bodyHtml = (
            <Suspense fallback={
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
            }
            >
                <Router />
            </Suspense>
        );

    } else {
        bodyHtml = (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    {routes}
                </Suspense>
            </div>

        );
    }

    return (
        <>
            {bodyHtml}
            {shortcutURL}
        </>
    )

};



